import { FinesLog } from "@/components/finance/FinesLog";

export default function FinesPage() {
  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 py-8" data-testid="fines-page">
      <FinesLog />
    </div>
  );
}
